import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Row, Col, Form, ListGroup } from 'react-bootstrap';


function UtilityFormModal ({ isOpen, closeModal }) {
    const handleFileUpload = (e) => {
        e.preventDefault();
        const inputElement = document.getElementById('close-loop-upload-sh-utility');
        const file = inputElement.files[0];
        if(file) {
            const formPayload = new FormData();
            formPayload.append('file', file);
            try {
                axios({
                    url: '/close_loop/utility/create_sh_file',
                    method: 'POST',
                    data: formPayload,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(response => {
                    console.log(response);
                    if(response && response.status === 200) {
                        inputElement.value = '';
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', response.headers["content-disposition"].split("filename=")[1]);
                        document.body.appendChild(link);
                        link.click();
                        closeModal();
                    } else {
                        console.log('Error Occurred');
                        inputElement.value = '';
                    }
                }).catch(error => {
                    console.log(error)
                })
            } catch(error) {
                console.log(error)
            }
        }
    }

    const generateSampleJSON = () => {
        const jsonFormat = {
            file_system: "s3-filesystem",
            files: [
                {
                    xosc_file: "/<path-to-the-xosc-file>/file1.xosc",
                    image_file: "/<path-to-the-image-file>/image1.png",
                    description: "some valid description about the scenario"
                },
                {
                    xosc_file: "/<path-to-the-xosc-file>/file2.xosc",
                    image_file: "/<path-to-the-image-file>/image2.png",
                    description: "some valid description about the scenario"
                }
            ]
        }
        const link = document.createElement('a');
        const data = URL.createObjectURL(
        new Blob([JSON.stringify(jsonFormat, undefined, 2)],
        { type: 'application/json' }) );
        link.setAttribute('href', data);
        link.setAttribute('download', `sample-json-${getDate()}.json`);
        document.body.appendChild(link);
        link.click();
    }

    const getDate = () => {
        const today = new Date();
        const dd = String(today.getDate()).padStart(2, '0');
        const mm = String(today.getMonth() + 1).padStart(2, '0')
        const yyyy = today.getFullYear();
        const hh = String(today.getHours()).padStart(2, '0');
        const min = String(today.getMinutes()).padStart(2, '0');
        const ss = String(today.getSeconds()).padStart(2, '0');

        return `${dd}-${mm}-${yyyy}-${hh}-${min}-${ss}`
    }

    return (
        <Modal isOpen={isOpen}>
            <ModalHeader
                style={{
                    backgroundColor: '#757AF7',
                    color: '#FFFFFF'
                }}
                toggle={closeModal}
            >
                Download sh Utility File
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col md={12}>
                        <Form onSubmit={handleFileUpload}>
                            <ListGroup>
                                <ListGroup.Item>
                                    <Row>
                                        <Col md={5}>
                                            Sample JSON Format
                                        </Col>
                                        <Col md={7}>
                                            <Button
                                                type='button'
                                                onClick={generateSampleJSON}
                                                data-testid="download-json-file"
                                                style={{
                                                    backgroundColor: '#757AF7',
                                                    color: '#FFFFFF'
                                                }}
                                            >
                                                Download JSON Format
                                            </Button>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <Row>
                                        <Col md={5}>
                                            Json File :
                                        </Col>
                                        <Col md={7}>
                                            <input
                                                type='file'
                                                id='close-loop-upload-sh-utility'
                                                data-testid='close-loop-upload-sh-utility'
                                                accept='application/json'
                                                required
                                            />
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                                <ListGroup.Item>
                                    <Row>
                                        <Col className='text-center'>
                                            <Button
                                                type="submit"
                                                data-testid="download-sh-file"
                                                style={{
                                                    backgroundColor: '#757AF7',
                                                    color: '#FFFFFF'
                                                }}
                                            >
                                                Download
                                            </Button>
                                        </Col>
                                    </Row>
                                </ListGroup.Item>
                            </ListGroup>
                        </Form>
                    </Col>
                </Row>
            </ModalBody>
        </Modal>
    )
}

UtilityFormModal.propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func
  }

export default UtilityFormModal;